// /**
//  * @format
//  */

import { AppRegistry, Platform, Text, View } from "react-native";
import App from "./App";
import appJson from "./app.json";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

AppRegistry.registerComponent(appJson.name, () => App);

if (Platform.OS === "web") {
  AppRegistry.runApplication(appJson.name, {
    initialProps: {},
    rootTag: document.getElementById("root"),
  });
}

reportWebVitals();

// An installed PWA can keep a previous build's shell alive. When that shell asks
// for a chunk the new deployment no longer ships, the page dies with "Loading
// chunk N failed" (or "Unexpected token '<'" when the server answers with the
// SPA index.html). Recover once instead of leaving the user on a dead screen:
// drop the stale service workers and their caches, then reload the fresh shell.
const CHUNK_ERROR = /Loading chunk [\w.-]+ failed|ChunkLoadError/;
const RELOAD_KEY = 'zeero:chunk-reload-at';
let recovering = false;

const recoverFromChunkError = async () => {
  if (recovering) {
    return;
  }
  const lastAttempt = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
  // Give up after one attempt per minute so a genuinely broken deploy cannot
  // trap the user in a reload loop.
  if (Date.now() - lastAttempt < 60000) {
    return;
  }
  recovering = true;
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(registration => registration.unregister()));
    }
    if (typeof caches !== 'undefined') {
      const names = await caches.keys();
      await Promise.all(names.map(name => caches.delete(name)));
    }
  } finally {
    window.location.reload();
  }
};

const handleChunkError = event => {
  const message = String(
    event?.reason?.message || event?.error?.message || event?.message || '',
  );
  if (CHUNK_ERROR.test(message)) {
    recoverFromChunkError();
  }
};

window.addEventListener('error', handleChunkError);
window.addEventListener('unhandledrejection', handleChunkError);
